import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "tr" }
const _hoisted_4 = /*#__PURE__*/_createVNode("td", { rowspan: 2 }, "测试场景", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("td", { rowspan: 2 }, "趋势风险", -1)
const _hoisted_6 = { class: "tr" }
const _hoisted_7 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", null, "终极生化-花果山"),
  /*#__PURE__*/_createVNode("td", null, [
    /*#__PURE__*/_createTextVNode(" 38.1 "),
    /*#__PURE__*/_createVNode("span", null, "（2↑）")
  ]),
  /*#__PURE__*/_createVNode("td", null, "38.1"),
  /*#__PURE__*/_createVNode("td", null, "低风险")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "◆", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_12 = { style: {"margin":"0 120px 0 40px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_time_picker = _resolveComponent("el-time-picker")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, {
            style: {"display":"flex","justify-content":"center"},
            id: "perf_report"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.object, (item, index) => {
                  return (_openBlock(), _createBlock("ul", { key: index }, [
                    _createVNode("li", null, _toDisplayString(index) + " : " + _toDisplayString(item), 1)
                  ]))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.object, (item, key, index) => {
                  return (_openBlock(), _createBlock("ul", { key: index }, [
                    _createVNode("li", null, _toDisplayString(index) + _toDisplayString(key) + " : " + _toDisplayString(item), 1)
                  ]))
                }), 128)),
                _createVNode("ul", null, [
                  _createVNode("li", null, _toDisplayString(_ctx.object.name), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.object.url), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.object.slogan), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.entries(_ctx.Aarray1), (item, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createTextVNode(_toDisplayString(item[0]) + " ", 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.entries(item[1]), (item1, index1) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index1,
                        style: {"display":"flex"}
                      }, [
                        _createTextVNode(_toDisplayString(item1[0]) + " : ", 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.entries(item1[1]), (item2, index2) => {
                          return (_openBlock(), _createBlock("div", { key: index2 }, _toDisplayString(item2[1]), 1))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                }), 128)),
                _createVNode("table", _hoisted_2, [
                  _createVNode("tr", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("td", {
                      colspan: _ctx.dataa.length
                    }, " 平均FPS趋势(1.0.190.754-ts对比1.0.190.754) ", 8, ["colspan"]),
                    _hoisted_5
                  ]),
                  _createVNode("tr", _hoisted_6, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataa, (item, index) => {
                      return (_openBlock(), _createBlock("td", { key: index }, _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  _hoisted_7
                ]),
                _hoisted_8,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.entries(_ctx.obj), (item, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createVNode("p", null, _toDisplayString(item[0]), 1)
                  ]))
                }), 128)),
                _createVNode("p", null, _toDisplayString(_ctx.obj["未完成"]), 1),
                _createVNode("div", null, [
                  _createVNode(_component_el_form, {
                    model: _ctx.ruleForm,
                    ref: "ruleFormaass",
                    "label-width": "100px",
                    class: "demo-ruleForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "活动名称",
                        prop: "name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ruleForm.name = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "活动区域",
                        prop: "region"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.ruleForm.region,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ruleForm.region = $event)),
                            placeholder: "请选择活动区域"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "区域一",
                                value: "shanghai"
                              }),
                              _createVNode(_component_el_option, {
                                label: "区域二",
                                value: "beijing"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "活动时间",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 11 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "date1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    type: "date",
                                    placeholder: "选择日期",
                                    modelValue: _ctx.ruleForm.date1,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ruleForm.date1 = $event)),
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            class: "line",
                            span: 2
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 11 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "date2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_time_picker, {
                                    placeholder: "选择时间",
                                    modelValue: _ctx.ruleForm.date2,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ruleForm.date2 = $event)),
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "即时配送",
                        prop: "delivery"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.ruleForm.delivery,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.ruleForm.delivery = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "活动性质",
                        prop: "type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: _ctx.ruleForm.type,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ruleForm.type = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox, {
                                label: "美食/餐厅线上活动",
                                name: "type"
                              }),
                              _createVNode(_component_el_checkbox, {
                                label: "地推活动",
                                name: "type"
                              }),
                              _createVNode(_component_el_checkbox, {
                                label: "线下主题活动",
                                name: "type"
                              }),
                              _createVNode(_component_el_checkbox, {
                                label: "单纯品牌曝光",
                                name: "type"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "特殊资源",
                        prop: "resource"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.ruleForm.resource,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.ruleForm.resource = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { label: "线上品牌商赞助" }),
                              _createVNode(_component_el_radio, { label: "线下场地免费" })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "活动形式",
                        prop: "desc"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.ruleForm.desc,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.ruleForm.desc = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetForm('ruleFormaass')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_el_checkbox, {
                    indeterminate: _ctx.isIndeterminate,
                    modelValue: _ctx.checkAll,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkAll = $event)),
                    onChange: _ctx.handleCheckAllChange
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["indeterminate", "modelValue", "onChange"]),
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.checked,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.checked = $event)),
                    onChange: _ctx.handleCheckOtherChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkedList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_col, {
                              span: 12,
                              key: item.id,
                              style: {"padding":"30px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_checkbox, {
                                  label: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode("span", _hoisted_12, _toDisplayString(item.name), 1),
                                    _createVNode("span", null, _toDisplayString(item.phone), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}